import React from 'react';
import { Box } from '@mui/system';
import * as Styled from '../SearchAutocompleteResults.styles';
import { DidYouMeanWrapperProps } from '../SearchAutocompleteResults.types';

export const DidYouMeanWrapper: React.FC<DidYouMeanWrapperProps> = ({
  query,
  correctedQuery,
  onQueryClick,
}) => {
  return (
    <Styled.CorrectedQueryWrapper>
      <Box display="flex" flexDirection="column">
        <Styled.CorrectionLine variant="body" mb="0.6em">
          <strong className="resultsLabel">Show Results for</strong>
          <Styled.CorrectionLink
            dense
            underlined
            variant="text"
            color="inherit"
            onClick={() => onQueryClick?.(correctedQuery)}
          >
            {correctedQuery?.trim()}
          </Styled.CorrectionLink>
        </Styled.CorrectionLine>
        <Styled.CorrectionLine variant="tiny">
          <span className="resultsLabel">Search instead for</span>
          <Styled.CorrectionLink
            dense
            underlined
            variant="text"
            color="inherit"
            onClick={() => onQueryClick?.(query)}
          >
            {query?.trim()}
          </Styled.CorrectionLink>
        </Styled.CorrectionLine>
      </Box>
    </Styled.CorrectedQueryWrapper>
  );
};
